import styles from './CognitiveAidOverlay.module.css';

/**
 * Emergency-Manual cognitive-aid card shown on the LEARNER monitor.
 * The instructor pushes a card via the store (`activeAidCard`); this renders it
 * as a right-anchored panel over the monitor. Read-only for the student.
 */
export default function CognitiveAidOverlay({ card }) {
  if (!card) return null;
  // Defensive: never throw on a malformed/partial card (e.g. from a stale sync).
  const lines = Array.isArray(card.lines) ? card.lines : [];
  if (!card.title && lines.length === 0) return null;
  const isInvestigation = card.kind === 'investigation';
  return (
    <div className={styles.wrap}>
      <div className={`${styles.card} ${isInvestigation ? styles.cardInv : ''}`}>
        <div className={styles.head}>
          <span className={`${styles.badge} ${isInvestigation ? styles.badgeInv : ''}`}>
            {isInvestigation ? 'INVESTIGATION' : 'EMERGENCY MANUAL'}
          </span>
          {card.scenario && <span className={styles.scenario}>{card.scenario}</span>}
        </div>
        <div className={styles.title}>{card.title}</div>
        <ul className={styles.list}>
          {lines.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
